import { Modal } from './Modal';

interface AtalhosModalProps {
  open: boolean;
  onClose: () => void;
}

interface Atalho {
  tecla: string;
  descricao: string;
}

const ATALHOS_GLOBAIS: Atalho[] = [
  { tecla: '?', descricao: 'Abrir este painel de atalhos' },
  { tecla: 'G + D', descricao: 'Ir para Dashboard' },
  { tecla: 'G + P', descricao: 'Ir para PDV' },
  { tecla: 'G + V', descricao: 'Ir para Vendas' },
  { tecla: 'G + C', descricao: 'Ir para Comandas' },
  { tecla: 'G + X', descricao: 'Ir para Caixa' },
  { tecla: 'G + R', descricao: 'Ir para Relatórios' },
];

const ATALHOS_PDV: Atalho[] = [
  { tecla: 'F2', descricao: 'Focar busca de produtos' },
  { tecla: 'F3', descricao: 'Selecionar comanda' },
  { tecla: 'F7', descricao: 'Aplicar desconto' },
  { tecla: 'F8', descricao: 'Abrir pagamento' },
  { tecla: 'F9', descricao: 'Finalizar venda' },
  { tecla: 'Esc', descricao: 'Fechar modal / cancelar' },
  { tecla: '+ / -', descricao: 'Aumentar / diminuir quantidade do item' },
  { tecla: 'Delete', descricao: 'Remover item selecionado' },
];

const ATALHOS_CAIXA: Atalho[] = [
  { tecla: 'Ctrl + Enter', descricao: 'Confirmar movimento' },
  { tecla: 'Ctrl + P', descricao: 'Imprimir Relatório Z' },
];

function Secao({ titulo, atalhos }: { titulo: string; atalhos: Atalho[] }) {
  return (
    <div>
      <h3 className="mb-2 text-sm font-semibold text-slate-900">{titulo}</h3>
      <div className="divide-y divide-slate-100 rounded-lg border border-slate-200">
        {atalhos.map((a) => (
          <div key={a.tecla} className="flex items-center justify-between gap-3 px-3 py-2 text-sm">
            <span className="text-slate-700">{a.descricao}</span>
            <kbd className="rounded border border-slate-300 bg-slate-50 px-2 py-0.5 font-mono text-xs text-slate-700">
              {a.tecla}
            </kbd>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AtalhosModal({ open, onClose }: AtalhosModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Atalhos de teclado"
      description="Acelere sua operação usando o teclado."
      size="lg"
    >
      <div className="space-y-5">
        <Secao titulo="Navegação" atalhos={ATALHOS_GLOBAIS} />
        <Secao titulo="PDV" atalhos={ATALHOS_PDV} />
        <Secao titulo="Caixa" atalhos={ATALHOS_CAIXA} />
      </div>
    </Modal>
  );
}
